import React from 'react';
import { useAtomValue } from 'jotai';
import classNames from 'classnames/bind';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import useCustomRecommend from '@/hooks/custom/useCustomRecommend';
import {
  getFilteredRecommendsByDestinations,
  getFilterRecommendsBySchedule,
  getTargetRecommends,
} from '@/utils/custom-travel';
import { separateThousandsGroups } from '@/utils/number';
import styles from './SelectBudgetForm.module.scss';

const cx = classNames.bind(styles);

const RecommendBudget = () => {
  const { destinations, tourSchedule } = useAtomValue(customTravelFormStateAtom);

  const customRecommends = useCustomRecommend();
  const recommendsFilterByDestination = getFilteredRecommendsByDestinations(customRecommends, destinations);
  const recommendsFilterBySchedule = getFilterRecommendsBySchedule(recommendsFilterByDestination, tourSchedule);
  const recommendsByPrices = getTargetRecommends(recommendsFilterBySchedule);

  if (!recommendsByPrices.length) return null;

  return (
    <>
      <div
        className={cx('announce')}
        data-event-nlog="imp"
        data-event-area-code="customtravel.recommendbudget"
        data-event-value={recommendsByPrices
          .map(({ name, minPrice, maxPrice }, i) => `${name}-${minPrice}-${maxPrice}-${i}`)
          .join(',')}
      >
        {recommendsByPrices.map(({ name, minPrice, maxPrice }, idx) => {
          const maxPriceText =
            minPrice !== maxPrice ? `에서 ${separateThousandsGroups((maxPrice || 0) / 10000)}만원` : '';
          return (
            <p key={idx}>
              {name} 여행의
              <em>
                {`성인 1인당 여행 비용은 일반적으로 ${separateThousandsGroups((minPrice || 0) / 10000)}만원${maxPriceText} 이에요.`}
              </em>
            </p>
          );
        })}
      </div>
      <div className={cx('notice')}>
        지난 1 년간, 네이버 패키지여행 상품 중 ‘풀패키지' 유형 예약 데이터를 기반으로 제공하는 정보입니다.
      </div>
    </>
  );
};

export default RecommendBudget;
